import { buildPermission } from "portal/utils/auth";
import { BulkEditor } from "portal/components/config/BulkEditor";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import React, { FunctionComponent } from "react";

const _AdminConfigBulk: FunctionComponent = () => {
  return <BulkEditor />;
};

export const AdminConfigBulk = withAuthorizationRequired(
  buildPermission(
    PermissionAction.update,
    PermissionResource.configs,
    PermissionDomain.all
  ),
  _AdminConfigBulk
);
